import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxPermissionsService } from 'ngx-permissions';
import * as moment from 'moment';
import { UtilsService } from './services/utils.service';
import { AuthService } from './services/auth.service';
import { environment } from 'src/environments/environment';
import { appConfigService } from './services/app-config.service';
import { MsalService } from '@azure/msal-angular';
import { firstValueFrom, interval, takeWhile } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  showHeader: boolean = false;
  title = 'inv-app';
  subscription;
  alive = true;

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly msalService: MsalService,
    private readonly utilsService: UtilsService,
    private readonly ngxPermissionsService: NgxPermissionsService,
    public readonly translate: TranslateService,
    public readonly appConfig: appConfigService
  ) {
    translate.addLangs(['en', 'es']);
    translate.setDefaultLang('en');
    moment.locale(window.navigator.language.split('-')[0]);
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.roles) {
      this.ngxPermissionsService.loadPermissions(user.roles);
    }
    this.setGoogleAnalytics();
  }

  async ngOnInit() {
     // Handle redirect/popup callbacks
    await firstValueFrom(this.msalService.handleRedirectObservable());

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.showHeader = this.activatedRoute.firstChild.snapshot.data.showHeader !== false;
      }
    });

    if (!this.utilsService.inPortal() && this.authService.currentUser?.exp) {
     this.authService.verifyAndRenewToken().then(async (isValidToken) => {
        if (isValidToken) {
          //console.log("token valido", isValidToken);
        }
      });
    }
  }

  ngOnDestroy() {
    this.alive = false;
    this.authService.terminateTokenRefreshWorker();
  }

 private setGoogleAnalytics(): void {
  if (!environment.gaTrackingId) return;

    // 1. Cargar Google Tag Manager script
    const gTagScript = document.createElement('script');
    gTagScript.async = true;
    gTagScript.src = `https://www.googletagmanager.com/gtag/js?id=${environment.gaTrackingId}`;
    //gTagScript.setAttribute('nonce', 'MjE0LDExNywzNSwxMTA='); // Usa el mismo nonce que tu CSP
    document.head.appendChild(gTagScript);

    // 2. Esperar a que se cargue el script antes de ejecutar gtag
    gTagScript.onload = () => {
      // Inicializar dataLayer y gtag sin usar innerHTML
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).gtag = function () {
        (window as any).dataLayer.push(arguments);
      };

      // Ejecutar configuración inicial
      (window as any).gtag('js', new Date());
      (window as any).gtag('config', environment.gaTrackingId);

      // Exponer función para enviar eventos si es necesario
      (window as any).SendGAEvent = function (eventName: string, eventParameters?: any) {
        if (typeof (window as any).gtag === 'function') {
          (window as any).gtag('event', eventName, eventParameters || {});
        }
      };
    };
  }

}
